// import config from 'config';
import { Api } from "../helpers";

export const userService = {
  getUser,
  login,
  logout,
  storeSignature,
  getSignature,
  getInstallers
};

// get the user {}
function getUser(options) {
  return Api()
    .get("/user")
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// get user signature
// base64
function getSignature(options) {
  return Api()
    .get("/user/signature")
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// send user signature to backend and store it
// file || base64
function storeSignature(options) {

  let formData = new FormData();

  if (options.signatureFile) formData.append("signatureFile", options.signatureFile);
  if (options.signature64) formData.append("signature64", options.signature64);

  return Api()
    .post("/user/signature", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// log the user in
// pass user name and pass to back-end for auth
function login(options) {
  return Api()
    .post("/user/authenticate", options)
    .then(response => {
      // login successful if there's a jwt token in the response
      // return user
      // {id: 1, name: "Sasa Aleksic", username: "sal", secondname: "Aleksic", title: "Field Engineer", …}
      return response;
    })
    .catch(err => {

      return Promise.reject(err.data);
    });
}

// log the user out
function logout() {
  return Api()
    .post("/user/forget")
    .then(response => {
      return response;
    })
    .catch(err => {
      return Promise.reject(err.data);
    });
}

// get all installers having at least one work-report (finalized)
function getInstallers(options) {
  return Api()
    .get("/installers")
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
